import PlanInput from "components/PlanInput";
import React, { useEffect, useState } from "react";
import { Plan } from "types/plan";

type Props = {
  plans: Plan[];
};

const Plans: React.FC<Props> = ({ plans }): JSX.Element => {
  const [planMonth, setPlanMonth] = useState<Plan>({} as Plan);
  const [planOneTime, setPlanOneTime] = useState<Plan>({} as Plan);

  useEffect(() => {
    setPlanMonth(plans.find((p) => p.type === "recurring") || ({} as Plan));
    setPlanOneTime(plans.find((p) => p.type === "one_time") || ({} as Plan));
  }, [plans]);

  return (
    <>
      <span
        className="ml-5 font-sora text-sm"
        style={{
          fontStyle: "normal",
          fontWeight: 400,
          color: "#A5A5A5",
        }}
      >
        Plan
      </span>
      <div className="flex flex-row mt-1 ml-5">
        <div className="flex flex-col w-1/2 mr-3">
          <PlanInput title={"Monthly"} value={planMonth.unit_amount} />
        </div>
        <div className="flex flex-col w-1/2 ml-3">
          <PlanInput title={"One Time"} value={planOneTime.unit_amount} />
        </div>
      </div>
    </>
  );
};

export default Plans;
